// extracted by mini-css-extract-plugin
export var brand = "_1q-9";
export var button = "_1q-0";
export var chevron = "_1q-v";
export var chevronButton = "_1q-w";
export var content = "_1q-n";
export var danger = "_1q-g";
export var dangerOutlined = "_1q-h";
export var dark = "_1q-l";
export var darkTheme = "_1q-c";
export var extraSmall = "_1q-4";
export var fullWidth = "_1q-8";
export var ghost = "_1q-d";
export var gray = "_1q-t";
export var icon = "_1q-p";
export var iconButton = "_1q-s";
export var iconButtonBorder = "_1q-x";
export var iconButtonBorderDark = "_1q-y";
export var iconButtonBorderLight = "_1q-z";
export var iconLeft = "_1q-q";
export var iconRight = "_1q-r";
export var large = "_1q-1";
export var light = "_1q-m";
export var medium = "_1q-2";
export var micro = "_1q-5";
export var nano = "_1q-7";
export var outlined = "_1q-k";
export var pending = "_1q-a";
export var primary = "_1q-i";
export var shadow = "_1q-o";
export var small = "_1q-3";
export var solidLight = "_1q-e";
export var solidLightBrand = "_1q-f";
export var spinner = "_1q-u";
export var transparent = "_1q-j";
export var warning = "_1q-b";
export var wideNano = "_1q-6";